@if (dataSource.data.length) {
  <mat-card class="card">
    <mat-card-title class="mb-2">{{ title() }}</mat-card-title>
    <mat-card-content class="p-0">
      <div class="flex justify-between items-end mb-2">
        <app-table-search-input
          (searchDataEvent)="search.set($event)"
          placeholder="Search"
        />
        <app-table-zoom
          (zoomChanged)="zoom.set($event)"
          tableId="device-attributes"
        />
      </div>

      <div [style.zoom]="zoom()">
        <table
          class="w-full main-table"
          [dataSource]="dataSource"
          mat-table
          matSort
          matSortActive="friendlyName"
          matSortDirection="asc"
        >

          <ng-container matColumnDef="friendlyName">
            <th
              *matHeaderCellDef
              mat-header-cell
              mat-sort-header="friendlyName"
            > Name </th>
            <td
              *matCellDef="let attr"
              mat-cell
            > {{ attr.friendlyName || attr.name }} </td>
          </ng-container>

          <ng-container matColumnDef="value">
            <th
              *matHeaderCellDef
              mat-header-cell
            > Value </th>
            <td
              *matCellDef="let attr"
              mat-cell
            >
              @if (attr.value) {
                <div class="flex items-center">
                  <ng-container *ngTemplateOutlet="value; context: { $implicit: attr }" />
                  <avs-copy [value]="attr.value" />
                </div>
              } @else {
                —
              }
            </td>
          </ng-container>

          <tr
            *matHeaderRowDef="displayedColumns"
            mat-header-row
          ></tr>
          <tr
            *matRowDef="let row; columns: displayedColumns;"
            mat-row
          ></tr>
        </table>
        @if (!dataSource.data.length) {
          <avs-no-data-placeholder
            [resultContent]="!!search()"
            noDataText="No attributes yet"
          />
        }
      </div>
    </mat-card-content>
  </mat-card>

  <ng-template
    #value
    let-attr
  >
    @switch (attr.name) {
      @case ('firmware') {
        <span class="mr-auto">{{ attr.value }}</span>

        @if (attr.name === 'firmware') {
          <avs-firmware-status
            [config]="{
            deviceId: device().id,
            firmware: $any(device()).latestFirmware,
            manufacturerId: $any(device()).deviceModelInformation?.make?.id,
            version: attr.value
          }"
            avsRestrictedEl
          />
        }
      }

      @case ('ipAddress') {
        @if (attr.value) {
          <a
            class="mr-auto underline"
            [href]="'http://' + attr.value + '/' + ($any(device()).hyperlink || '')"
            rel="noopener noreferrer"
            target="_blank"
          >
            {{ attr.value}}
          </a>
        }
      }

      @default {
        <span class="mr-auto">{{ attr.value }}</span>
      }
    }
  </ng-template>
}
